// extracted by mini-css-extract-plugin
export var header = "SkZyEeG+";
export var alignCenter = "px7PNFA6";
export var title = "erM8DEfz";
export var description = "DTLVyJQh";